/* Lấy mốc là ngày 15/09/2025
0h15 < x ≤ 4h: giao sớm nhất vào 7h sáng cùng ngày (15/09/2025)
4h < x ≤ 7h: giao sớm nhất vào 10h sáng cùng ngày (15/09/2025)
7h < x ≤ 10h: giao sớm nhất vào 13h chiều cùng ngày (15/09/2025)
10h < x ≤ 0h15 hôm sau: giao sớm nhất vào 6h sáng hôm sau (16/09/2025)

*/

import moment from 'moment';

export const getTimeDeliveryEarliest = () => {
  const now = moment();

  // Giờ giới hạn trong ngày hiện tại
  const limit1 = moment().hour(0).minute(15); // 0h15
  const limit2 = moment().hour(4).minute(0); // 4h00
  const limit3 = moment().hour(7).minute(0); // 7h00
  const limit4 = moment().hour(10).minute(0); // 10h00

  let deliveryTime;

  if (now.isAfter(limit1) && now.isSameOrBefore(limit2)) {
    deliveryTime = moment().hour(7).minute(0);
  } else if (now.isAfter(limit2) && now.isSameOrBefore(limit3)) {
    deliveryTime = moment().hour(10).minute(0);
  } else if (now.isAfter(limit3) && now.isSameOrBefore(limit4)) {
    deliveryTime = moment().hour(13).minute(0);
  } else {
    deliveryTime = moment().add(1, 'days').hour(6).minute(0);
  }

  return deliveryTime.format('H:mm DD/MM/YYYY').replace(':', 'h');
};
